import React from 'react';
import PageHero from '../components/PageHero';
import Contact from '../components/Contact';
import { heroImages } from '../mock';

export default function ContactPage() {
  return (
    <>
      <PageHero
        eyebrow="Contact Us"
        title="Let’s Grow Your Business Together"
        sub="Share a few details about your brand and our team will reach out with a tailored growth plan."
        image={heroImages.analytics}
      />
      <Contact />
    </>
  );
}
